import { collection, onSnapshot } from 'firebase/firestore';
import React from 'react';

import { FirebaseService } from '../Firebase/Firebase';
import { CustomDrawingDataType, DrawingDataType } from '../Utils/types';

// The organisation's Drawings, live and newest first; loading until the first snapshot (OQ-161, flows/drawings.md §1).
export const useDrawings = (organisationId: string | undefined) => {
  const [state, setState] = React.useState<{ drawings: CustomDrawingDataType[]; loading: boolean }>({
    drawings: [],
    loading: !!organisationId
  });

  React.useEffect(() => {
    if (!organisationId) {
      setState({ drawings: [], loading: false });
      return;
    }
    setState((current) => ({ ...current, loading: true }));
    return onSnapshot(collection(FirebaseService.firestore, `organisations/${organisationId}/drawings`), (snap) =>
      setState({
        drawings: snap.docs
          .map((doc) => ({ docId: doc.id, ...(doc.data() as DrawingDataType) }))
          .sort((a, b) => b.createdAt.toMillis() - a.createdAt.toMillis()),
        loading: false
      })
    );
  }, [organisationId]);

  return state;
};
